import { ProfilerProduct } from "../../../../types/ProfilerProduct";


type BeautyProfilerSecondaryFragrancesProps = {
  topSecondaryFragrances: {
    secondFetiche: ProfilerProduct | null;
    topLoubiworld: ProfilerProduct | null;
  };
};

export const BeautyProfilerSecondaryFragrances = 
  ({ topSecondaryFragrances }: BeautyProfilerSecondaryFragrancesProps) => {
    return (
      <>
        <div className="text-[#050505] text-center font-garamond-italic text-[22px] font-normal italic">
          More scents to express your allure...
        </div>
        <div className="flex items-start gap-4 self-stretch">
          <FragranceCard
            name={topSecondaryFragrances.secondFetiche?.label}
            imagePath={`/beauty-profiler/secondary-fragrances/${topSecondaryFragrances.secondFetiche?.id}.png`}
          />
          <FragranceCard
            name={topSecondaryFragrances.topLoubiworld?.label}
            imagePath={`/beauty-profiler/secondary-fragrances/${topSecondaryFragrances.topLoubiworld?.id}.png`}
          />
        </div>
      </>
    );
  };



export type FragranceCardProps = {
    name: string | undefined;
    imagePath: string | undefined;
  };
  
  export const FragranceCard = ({ name, imagePath }: FragranceCardProps) => {
    return (
      <div className="flex flex-col justify-between items-start flex-1 self-stretch p-4 rounded-lg bg-gradient-to-b from-[#FAF5F1] to-[#F5EEEB] gap-6">
        <h3 className="text-[#CE0A2C] font-minion text-[16px] font-normal">
          {name}
        </h3>
        <img src={imagePath} alt={imagePath} />
      </div>
    );
  };
  